import { Plus } from "lucide-react"
import { NavLink } from "react-router"

import AuthWrap from "@/components/AuthWrap.tsx"
import { Button } from "@/components/ui/button.tsx"
import DataPointReportList from "@/features/datapoints/components/report/DataPointReportList.tsx"

export default function Reports() {
  return (
    <div>
      <AuthWrap role="Report.Admin">
        <NavLink to="/datapoints/reports/new">
          <Button variant="outline" className="w-[160px] p-6">
            <Plus />
            Add Report
          </Button>
        </NavLink>
      </AuthWrap>
      <div className="rounded-md shadow-sm border mt-2 overflow-hidden">
        <DataPointReportList />
      </div>
    </div>
  )
}
